import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import {OverseaDeliveryCustom} from '@web/core/constants'
import makeSlice from '@web/slices/personalCustomsClearance/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {deliveryNothingOrder, purchaser, products} = payload.data
                const isOverseasDelivery = !deliveryNothingOrder && payload.isOverseasDelivery
                state.isOverseasDelivery = isOverseasDelivery
                state.scene = purchaser.personalCustomsCode ? 'view' : 'edit'
                state.customType = isOverseasDelivery
                    ? products.some(({individualCustomUniqueCodeUsed}) => individualCustomUniqueCodeUsed)
                        ? OverseaDeliveryCustom.INDIVIDUAL_CUSTOM_UNIQUE_CODE
                        : OverseaDeliveryCustom.BUSINESS_CUSTOM_CODE
                    : null

                if (purchaser.personalCustomsCodeInfo) {
                    state.saved = {
                        view: purchaser.personalCustomsCodeInfo.code,
                        hash: purchaser.personalCustomsCodeInfo.hash,
                        name: purchaser.personalCustomsReceiverName ?? '',
                        phone: purchaser.personalCustomsReceiverTelNo ?? '',
                    }
                }
            })
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                state.selected = payload.data.personalCustomsClearance.selected
            })
    },
})

export default slice.reducer
